export const MicroSoftConfig = {
  loginUrl: 'https://login.microsoftonline.com/',
  graphUrl: 'https://graph.microsoft.com/v1.0/',
  tenantId: import.meta.env.VITE_MICROSOFT_TENANT_ID,
  clientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID,
  shopId: 2126,
};

export function getTenantId(testing = false) {
  if (testing) {
    return '954988a0-7f34-4557-ba89-18644d18496b'; // Test tenant ID
  }
  return MicroSoftConfig.tenantId;
}

export function getClientId(testing = false) {
  if (testing) {
    return 'ea98566e-efb5-4808-a0b4-a219b905eac8'; // Test client ID
  }
  return MicroSoftConfig.clientId;
}

export function getShopId(testing = false) {
  if (testing) {
    return 1424; // Test shop ID
  }
  return MicroSoftConfig.shopId;
}
